<template>
  <div class="">
    <label for="date-range-start-input">Start</label>
    <input
      type="date"
      class="m-2 p-2 border bg-gray-100"
      id="date-range-start-input"
      label="Start"
      :value="dateToYYYYMMDD(startString)"
      @input="startString = valueAsDate($event.target as HTMLInputElement)"
    />
    <label for="date-range-start-input" class="ml-2">End</label>
    <input
      type="date"
      class="m-2 p-2 border bg-gray-100"
      label="End"
      :value="dateToYYYYMMDD(endString)"
      @input="endString = valueAsDate($event.target as HTMLInputElement)"
    />
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  start?: Date;
  end?: Date;
}>();

const emit = defineEmits<{
  (e: "change", range: { start: Date; end: Date }): void;
}>();

let startString = ref<Date>(
  props.start || new Date(new Date().setFullYear(new Date().getFullYear() - 5))
);
let endString = ref(props.end || new Date());

watch([startString, endString], (newValues) => {
  let startDate = new Date(newValues[0].toString());
  let endDate = new Date(newValues[1].toString());
  emit("change", { start: startDate, end: endDate });
});

function dateToYYYYMMDD(d: Date): string {
  // alternative implementations in https://stackoverflow.com/q/23593052/1850609
  return (
    d &&
    new Date(
      d.getTime()
      //- d.getTimezoneOffset() * 60 * 1000
    )
      .toISOString()
      .split("T")[0]
  );
}

function valueAsDate(dateBox: HTMLInputElement): Date {
  return dateBox.valueAsDate!;
}
</script>
